import { combineReducers } from "redux";

import {
  PEER_REVIEWER_RESULT_RESPONSE,
  PEER_REVIEWER_RESULT_FAILURE,
  PEER_REVIEWER_RESULT_REQUEST,
  PEER_REVIEWER_KEYWORD_RESPONSE,
  PEER_REVIEWER_KEYWORD_FAILURE,
  PEER_REVIEWER_KEYWORD_REQUEST,
  PEER_REVIEWER_UPDATE_TITLE,
  PEER_REVIEWER_UPDATE_ABSTRACT,
  PEER_REVIEWER_UPDATE_APPLICANT,
  PEER_REVIEWER_UPDATE_SELECTED_TOPICS,
  PEER_REVIEWER_KEYWORD_UPDATE,
  PEER_REVIEWER_RESULT_FILTER
} from "../../actions/types";

import conflict from "./conflict";

const initialState = {
  isFetching: false,
  error: false,
  isInitialScreen: true,
  experts: [],
  keywords: [],
  msg: "",
  grouped_keywords: [],
  totalExperts: "-",
  title: "",
  abstract: "",
  applicant: [],
  selectedTopics: [],
  isResultLoading: false,
  isResultError: false,
  filters: {
    year: "",
    terms: ""
  }
};

const setkeywordRequest = (state, action) => {
  return {
    ...state,
    isFetching: true,
    error: false,
    isInitialScreen: false,
    keywords: [],
    grouped_keywords: [],

    selectedTopics: [],
    experts: []
  };
};

const setkeywordResponse = (state, action) => {
  const { keywords = [], grouped_keywords } = action.payload;

  return {
    ...state,
    isFetching: false,
    error: false,
    isInitialScreen: false,
    keywords: keywords,
    grouped_keywords: grouped_keywords,
    msg: false
  };
};

const setSelectedTopics = (state, action) => {
  const selectedTopics = action.payload.selectedTopics;
  return {
    ...state,
    selectedTopics
  };
};

const setkeywordFailure = (state, action) => {
  return {
    ...state,
    isFetching: false,
    error: true,
    isInitialScreen: false
  };
};

const setRequest = (state, action) => {
  return {
    ...state,
    isResultLoading: true,
    isResultError: false,
    isInitialScreen: false,
    experts: [],
    filters: action.payload.filters || {},
    msg: false
  };
};

const setFailure = (state, action) => {
  return {
    ...state,
    isResultLoading: false,
    isResultError: true,
    isInitialScreen: false,
    msg: true
  };
};

const setTitle = (state, action) => {
  const title = action.payload.title;

  return {
    ...state,
    title
  };
};

const setAbstract = (state, action) => {
  const abstract = action.payload.abstract;

  return {
    ...state,
    abstract
  };
};

const setApplicant = (state, action) => {
  const applicant = action.payload.applicant || [];

  return {
    ...state,
    applicant,
    experts: []
  };
};

const setResponse = (state, action) => {
  let { experts = [], totalExperts = "-" } = action.payload;
  experts = experts || [];
  let msg = experts.length === 0;
  return {
    ...state,
    isResultLoading: false,
    isResultError: false,
    experts: experts,
    isInitialScreen: false,
    totalExperts,
   msg
  };
};

const updateTopicKeywords = (state, action) => {
  let { keywords } = action.payload;
  return {
    ...state,
    keywords: keywords || [],
    msg: false
  };
};

const updateResultFilters = (state, action) => {
  let filters = action.payload.filters || {
    year: "",
    terms: ""
  };
  return {
    ...state,
    filters: filters
  };
};

const inputs = (state = initialState, action) => {
  switch (action.type) {
    case PEER_REVIEWER_RESULT_RESPONSE:
      return setResponse(state, action);
      break;

    case PEER_REVIEWER_RESULT_FAILURE:
      return setFailure(state, action);
      break;

    case PEER_REVIEWER_RESULT_REQUEST:
      return setRequest(state, action);

    case PEER_REVIEWER_UPDATE_ABSTRACT:
      return setAbstract(state, action);

    case PEER_REVIEWER_UPDATE_TITLE:
      return setTitle(state, action);

    case PEER_REVIEWER_UPDATE_APPLICANT:
      return setApplicant(state, action);

    case PEER_REVIEWER_KEYWORD_REQUEST:
      return setkeywordRequest(state, action);

    case PEER_REVIEWER_KEYWORD_RESPONSE:
      return setkeywordResponse(state, action);

    case PEER_REVIEWER_KEYWORD_FAILURE:
      return setkeywordFailure(state, action);

    case PEER_REVIEWER_UPDATE_SELECTED_TOPICS:
      return setSelectedTopics(state, action);

    case PEER_REVIEWER_KEYWORD_UPDATE:
      return updateTopicKeywords(state, action);

    case PEER_REVIEWER_RESULT_FILTER:
      return updateResultFilters(state, action);

    default:
      return state;
      break;
  }
};

export default combineReducers({
  inputs: inputs,
  conflict: conflict
});
